export const maritalStatus = [
  { value: "MARRIED", label: "Married / Civil Partnership" },
  { value: "SINGLE", label: "Single" },
  { value: "DIVORCED", label: "Divorced / Dissolved Civil Partnership" },
  { value: "PARTNER", label: "Living with Partner" },
  { value: "WIDOWED", label: "Surviving Spouse / Civil Partner" }
];
